<ion-app>
  <ion-split-pane contentId="main-content" when="lg">
    <ion-menu menuId="side-menu" contentId="main-content" type="overlay" [disabled]="(labelsLoaded$ | async) === false || (isLogged$ | async) === false">
      <ion-content forceOverscroll="false">
        <div class="header">
          <img
            class="main-logo"
            alt="flowww me"
            src="assets/logo/logo_flowww_me.svg"
            title="flowww me">
          </div>
          <div class="content">
            <ion-menu-toggle [autoHide]="false">
              <app-item
                routerLinkActive="selected"
                routerDirection="root"
                routerLink="/agenda"
                icon="calendar-outline"
              [detailIcon]="false">{{ 'lbl_diary_day' | translate }}</app-item>
            </ion-menu-toggle>

            <ion-menu-toggle [autoHide]="false">
              <app-item
                routerLinkActive="selected"
                routerDirection="root"
                routerLink="/clients"
                icon="people-outline"
              [detailIcon]="false">{{ 'lbl_clients' | translate }}</app-item>
            </ion-menu-toggle>
          </div>

          <div class="footer">
            <app-item class="user-item" [detailIcon]="false" icon="person-circle-outline" lines="none">
              <ion-label>
                <h2>{{ username$ | async }}</h2>
              </ion-label>
            </app-item>

            <app-item [detailIcon]="false" lines="none">
              <ion-select
                mode="ios"
                [cancelText]="'lbl_cancel' | translate"
                [okText]="'lbl_accept' | translate"
                [interfaceOptions]="{ header: ('lbl_clinics' | translate) }"
                [compareWith]="clinicCompareFunction"
                [(ngModel)]="selectedClinic"
                (ngModelChange)="selectClinic($event)">
                @for (clinic of (clinics$ | async); track clinic) {
                  <ion-select-option [value]="clinic">
                    {{ clinic.name }}
                  </ion-select-option>
                }
              </ion-select>
            </app-item>

            <ion-menu-toggle [autoHide]="false">
              <app-item class="log-out" icon="log-out-outline" [detailIcon]="false" (click)="logout()">{{ 'lbl_log_out' | translate }}</app-item>
            </ion-menu-toggle>
          </div>
        </ion-content>
      </ion-menu>

      <ion-router-outlet #routerOutlet id="main-content"></ion-router-outlet>
    </ion-split-pane>

    <!-- Solo mientras el menú está deshabilitado: con las labels cargadas el menú
         ya ofrece salida (cambiar de clínica, clientes, cerrar sesión) -->
    @if ((initError$ | async); as initError) {
      @if ((isLogged$ | async) && (labelsLoaded$ | async) === false) {
        <div class="init-error">
          <p>{{ 'lbl_init_error' | translate }}</p>
          <app-button expanded icon="refresh-outline" (click)="retryInit()">{{ 'lbl_retry' | translate }}</app-button>
          <app-button class="log-out" expanded icon="log-out-outline" (click)="logout()">{{ 'lbl_log_out' | translate }}</app-button>
          <pre class="init-error-detail">{{ initError }}</pre>
        </div>
      }
    }

    @if (((loading$ | async) || (manualLoading$ | async)) && (skeleton$ | async) === false) {
      <app-loader></app-loader>
    }
  </ion-app>
